import { BookDemoRequestType } from '../types/apiResponse/bookDemo'
import { postData } from '../utils'

export const postBookDemo = async (bookDemoRequestForm: BookDemoRequestType) => {
  await postData('book-demo', bookDemoRequestForm).catch((e) => {
    throw e
  })
}
